<ngx-file-drop
  class="custom-file-drop"
  (onFileDrop)="dropped($event)"
  [multiple]="multiple"
  [accept]="accept()"
  [showBrowseBtn]="true"
  [browseBtnLabel]="''"
></ngx-file-drop>
<div class="dropzone-content text-primary flex w-full flex-col items-center justify-center gap-3 p-4">
  @if (!hideIcon()) {
    <dojo-image src="assets/images/upload/upload-file.svg" class="h-16 w-16" />
  }
  <div class="aligner flex flex-col gap-1">
    <div class="text-md font-semibold">{{ 'examdojo.question.tab_drop.drag_drop' | transloco }}</div>
    <div class="text-sm">{{ 'examdojo.question.tab_drop.browse_images' | transloco }}</div>
  </div>
  <dojo-button [fill]="'outline'" [customColor]="'sky'">{{
    'examdojo.question.tab_drop.browse' | transloco
  }}</dojo-button>
</div>
